'use client';

import { useRef, useState } from 'react';
import { useRouter } from 'next/navigation';
import { DMAlertDialog } from '@/components/alert-dialog';
import { DMButton } from '@/components/button';
import { PhoneInput } from '@/components/input/PhoneInput';
import DMInput from '@/components/input/TextInput';
import { PasswordInput } from '@/components/ui/password-input';
import { useToast } from '@/components/ui/use-toast';
import { zodResolver } from '@hookform/resolvers/zod';
import { signIn } from 'next-auth/react';
import { SubmitHandler, useForm } from 'react-hook-form';
import rewardLottie from '../../../public/lottie/Reward-Lottie3.json';
import { handleSignUpAction } from './actions';
import { ErrorMessage, SignUpSchema, SignUpSchemaType } from './types/signup';

const SignupWithEmail = () => {
  const { toast } = useToast();
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertDescription, setAlertDescription] = useState('');
  const [loginDetails, setLoginDetails] = useState<{
    email: string;
    password: string;
  }>({ email: '', password: '' });
  const pointDetails = useRef<any>(null);
  const router = useRouter();
  // const [phoneNumber, setPhoneNumber] = useState('');
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<SignUpSchemaType>({ resolver: zodResolver(SignUpSchema) });

  const onSubmit: SubmitHandler<SignUpSchemaType> = async data => {
    const response: any = await handleSignUpAction(data);
    setShowAlert(true);
    setAlertDescription(response?.description ?? '');
    setAlertTitle(response?.title ?? '');
    if (response?.status === 200) {
      if (response?.xpStatus?.status == 'success') {
        pointDetails.current = response?.xpStatus;
      }
      setLoginDetails({ email: data.email, password: data.password });
    }
  };

  const handleLogin = async (email: string, password: string) => {
    if (email && password) {
      setShowAlert(false);
      const response = await signIn('credentials', {
        email: email,
        password: password,
        redirect: false,
      });
      if (!response?.error) {
        // router.push('/')
        // router.refresh()
        setTimeout(() => {
          toast({
            title: `🎉 Woohoo ${pointDetails.current?.newXpBalance} XP`,
            description: "You've gained XP for Signup!",
            icon: rewardLottie,
          });
        }, 1000);
        router.refresh();
      }
    }
  };

  const okCallBack = () => handleLogin(loginDetails.email, loginDetails.password);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className='flex flex-col m-px gap-4 w-full items-start flex-1'
    >
      <DMAlertDialog
        open={showAlert}
        setOpen={setShowAlert}
        okCallBack={okCallBack}
        title={alertTitle}
        description={alertDescription}
        buttonTitle='Ok'
      />
      <div className='flex gap-3 w-full'>
        <DMInput
          type='text'
          label='First Name'
          placeholder='Enter First Name'
          inputMode='text'
          extra='w-full'
          register={register('firstName')}
          errorMessage={errors.firstName as ErrorMessage}
        />
        <DMInput
          type='text'
          label='Last Name'
          placeholder='Enter Last Name'
          inputMode='text'
          extra='w-full'
          register={register('lastName')}
          errorMessage={errors.lastName as ErrorMessage}
        />
      </div>
      <DMInput
        type='email'
        label='Email'
        extra='w-full'
        inputMode='email'
        placeholder='Enter Email'
        register={register('email')}
        errorMessage={errors.email as ErrorMessage}
      />

      {/* <div className='w-full'>
        <label
          htmlFor='phone'
          className='text-sm text-brand-primary-text ml-1 font-medium flex-1 w-full'
        >
          Phone
        </label>
        <PhoneInput
          className='w-full bg-brand-secondary rounded-md'
          value={phoneNumber}
          onChange={value => {
            setPhoneNumber(value);
            // Update the form value for validation
            setValue('phone', value, { shouldValidate: true });
          }}
          defaultCountry='IN'
          international
          placeholder='Enter a phone number'
          style={{ height: '50px', alignItems: 'center' }}
        />
        {errors?.phone?.message && (
          <p className='text-red-400 text-[11px]'>
            {errors.phone.message.toLowerCase().includes('invalid')
              ? 'Field is required'
              : errors.phone.message}
          </p>
        )}
      </div> */}
      {/* <div className="w-full">
        <div className="flex justify-between mb-1">
          <label className="label" htmlFor="">
            Experience
          </label>
          {errors?.experience?.message && (
            <p className="text-red-400 text-[11px] text-right">
              {errors?.experience?.message.toLowerCase().includes('invalid')
                ? 'Field is required'
                : errors?.experience?.message}
            </p>
          )}
        </div>

        <DMSelect
          onValueChange={value => setValue('experience', value, { shouldValidate: true })}
          defaultLabel="Select Experience"
          options={['Fresher', 'Experienced']}
          register={register('experience')}
        />
      </div> */}
      <PasswordInput
        type='password'
        placeholder='Enter Password'
        inputMode='text'
        register={register('password')}
        errorMessage={errors.password as ErrorMessage}
      />

      <DMButton
        type='submit'
        className='relative w-full py-3 text-center flex justify-center mt-2'
        variant='primary'
        disabled={isSubmitting}
        loading={isSubmitting}
      >
        Signup
      </DMButton>
      {/* <DMLink
        href="/login"
        variant="text"
        className="text-xs font-semibold mt-10 text-center w-full text-gray-300"
      >
        Already have an account? Login
      </DMLink> */}
    </form>
  );
};

export default SignupWithEmail;
